import React from 'react';
import PerformanceReport from '../components/PerformanceComponent/PerformanceReport';

const PerformancePage = () => {
  return (
    <div>
      <PerformanceReport />
    </div>
  );
};

export default PerformancePage;
